import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useLinkedToIndependent(): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const linkedToIndependent = (athleteId: string): Promise<AxiosResponse<null>> => {
    return client.put(`athletes/${athleteId}/linked-to-independent/`);
  };

  return useMutation(linkedToIndependent, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['connectedAthletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['paymentMethods'],
      });
    },
  });
}
